import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { UserSaveJSON } from "../models/json/userSaveJSON";
import { UploadStatus, UPLOAD_STATUS } from "../models/uploadStatus.model";
import { UploadStatusJSON } from "../models/json/uploadStatusJSON";

interface SyncDHLLabelStatus {
    id: number;
    amount_to_upload: number;
    success_amount: number;
    errored_amount: number;
    errored_references: string[];
    date_created: string;
    status: UPLOAD_STATUS;
}

export interface UploadDHLLabel {
    reference: string;
    recipient: UserSaveJSON;
    sender: UserSaveJSON | string;
    customer_number: string;
    mark: string;
}

const DHL_QUERY_PARAMS = {
    carrier: "DHL",
};

@Injectable()
export class DHLSyncService {
    constructor(private httpClient: HttpClient) {}

    syncDHLLabels(uploadData: UploadDHLLabel[]): Observable<SyncDHLLabelStatus> {
        const params = new HttpParams({ fromObject: DHL_QUERY_PARAMS });

        return this.httpClient.post<SyncDHLLabelStatus>(
            `${environment.apiBase}/packages/upload`,
            { items: uploadData },
            { params },
        );
    }

    getLatestUploadStatus(): Observable<UploadStatus | null> {
        const params = new HttpParams({ fromObject: DHL_QUERY_PARAMS });

        return this.httpClient
            .get<any>(`${environment.apiBase}/packages/upload/status/latest`, { params })
            .pipe(map(UploadStatus.fromJSON));
    }

    getUploadStatusById(id: number): Observable<UploadStatus | null> {
        const apiUrl = `${environment.apiBase}/packages/upload/status/${id}`;
        return this.httpClient
            .get<UploadStatusJSON | null>(apiUrl)
            .pipe(map((jsonResponse) => UploadStatus.fromJSON(jsonResponse)));
    }

    stopSync(id: number): Observable<any> {
        return this.httpClient.post(`${environment.apiBase}/packages/upload/stop`, {
            id,
        });
    }
}
